import { render, staticRenderFns } from "./BaseField.vue?vue&type=template&id=034bd392&scoped=true"
import script from "./BaseField.vue?vue&type=script&lang=js"
export * from "./BaseField.vue?vue&type=script&lang=js"
import style0 from "./BaseField.vue?vue&type=style&index=0&id=034bd392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034bd392",
  null
  
)

export default component.exports